import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { themeSpace } from 'styles/themeUtils';

export const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 99999;

  background-color: ${nuDSColor('black', 'defaultT70')};
`;

export const ModalCloseContent = styled.div`
  padding: ${themeSpace(0.5)};
  text-align: right;
`;
